import React from "react";
import { Helmet } from "react-helmet";

import Page from "../../components/layout/Page";

//@ts-ignore
import showroomBg from "../../assets/images/showroom-hero.jpg";
//@ts-ignore
import cat1 from "../../assets/images/automatizari.jpg";
//@ts-ignore
import img8 from "../../assets/images/pages/8.jpg";
//@ts-ignore
import img9 from "../../assets/images/pages/9.jpg";

export default function Modelhome() {
  return (
    <Page>
      {
        //@ts-ignore
        <Helmet>
          <title>Modelhome Loxone Cluj-Napoca: Showroom Casă Inteligentă</title>
          <meta
            name="description"
            content={`Experimentează viitorul unei case inteligente în showroom-ul Loxone din Cluj-Napoca. Simte confortul automatizării și programează o vizită gratuită!`}
          />
        </Helmet>
      }
      <div
        className="page-title with-background"
        style={{ backgroundImage: `url(${cat1})` }}
      >
        <div className="shade"></div>
        <h1>Modelhome Loxone, Cluj-Napoca</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <p>
            Cea mai bună metodă de a înțelege puterea unui{" "}
            <strong>sistem Loxone</strong> este să îl experimentezi. Conceptele
            de "casă inteligentă" pot părea abstracte, dar în{" "}
            <strong>showroom-ul nostru din Cluj-Napoca</strong>, ele prind
            viață. Te invităm să pășești într-un spațiu unde confortul,
            siguranța și eficiența energetică sunt controlate inteligent și
            automat. Simte pe propria piele cum tehnologia Loxone îți poate
            transforma locuința. <strong>Programează o vizită</strong> și
            descoperă viitorul.
          </p>
        </div>
      </div>
      <div className="an-section bg-1">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <h4 className="strong">Ce este un modelhome Loxone?</h4>
            <p className="mb-0">
              Nu este un simplu showroom. Este o <strong>locuință reală</strong>
              , <strong>complet automatizată</strong>, unde poți interacționa
              direct cu toate funcțiile unui sistem de casă inteligentă. Aici
              vei vedea cum luminile, jaluzelele, climatizarea și sistemul audio
              lucrează perfect pentru a crea o <strong>atmosferă ideală</strong>
              , <strong>adaptată nevoilor tale</strong>.
            </p>
          </div>
          <div className="an-col w-6">
            <img src={img8} className="max-400 center"></img>
          </div>
        </div>
      </div>
      <div className="an-section">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <img src={img9} className="max-400 center"></img>
          </div>
          <div className="an-col w-6">
            <h4 className="strong">Pentru cine este această experiență?</h4>
            <p className="mb-0">
              <strong>Proprietari de locuințe:</strong> Cei care construiesc sau
              renovează și doresc să descopere potențialul maxim al casei lor.
              <br></br>
              <br></br>
              <strong>Arhitecți și Designeri:</strong> Profesioniști care vor să
              integreze soluții de automatizare de top în proiectele lor.
              <br></br>
              <br></br>
              <strong>Dezvoltatori Imobiliari:</strong> Companii care doresc să
              ofere valoare adăugată și un avantaj competitiv proiectelor
              rezidențiale.<br></br>
              <br></br>
              <strong>Instalatori și Electricieni:</strong> Parteneri care vor
              să se specializeze în tehnologia viitorului.
            </p>
          </div>
        </div>
      </div>
      <div id="showroom">
        <div
          className="bg-section"
          style={{ backgroundImage: `url(${showroomBg})` }}
        ></div>
        <div className="shade"></div>
        <div className="an-section">
          <div className="an-content flex center">
            <div className="an-col w-8 text">
              <h1>
                Ești pregătit să faci pasul către o viață mai simplă și mai
                confortabilă?
              </h1>
              <p>
                Vizitele sunt gratuite și se fac pe bază de programare pentru a
                ne asigura că ai parte de toată atenția noastră. Un specialist
                Loxone îți va fi alături pentru a răspunde la toate întrebările.
              </p>
              <a
                className="special-button"
                style={{ marginTop: 16 }}
                href="/#contact"
              >
                Hai să discutăm proiectul tău.
              </a>
            </div>
            <div className="an-col w-4 blank"></div>
          </div>
        </div>
      </div>
    </Page>
  );
}
